import { Component, OnInit,ViewChild } from '@angular/core';
declare var $: any;
import { DataTableDirective } from 'angular-datatables';
import { UserService } from '../../../../shared/user.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';

declare var $: any;

import swal from 'sweetalert2';
import { Router, ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { ErrorHandler } from '../../../../shared/ErrorHandler';
@Component({
  selector: 'app-vlegrid',
  templateUrl: './vlegrid.component.html',
  styleUrls: ['./vlegrid.component.css']
})
export class VlegridComponent implements OnInit {
title="VLE Details";
dtOptions: any = {};
DistrictDetailsList: any[] = [];
empList :any =[];
isSearch: boolean;
data: any;
mode :any;
@ViewChild(DataTableDirective)
datatableElement: DataTableDirective;
dtTrigger: Subject<any> = new Subject();
constructor(public service : UserService,private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler) { }

ngOnInit(): void {
  this.GetDistrictDetails();
  this.empList = this.service.empList;
  //
  this.dtOptions = {
    dom: 'lBfrtip',
    lengthMenu: [[5, 10, 20, -1], [5, 10, 20, "All"]],
    scroll: "250px",
    select: true,
    buttons: [
      {
        extend: 'collection',
        text: 'Export',
        className: 'btn btn-radius',
        buttons: ['copy', 'csv', 'excel', 'pdf', 'print',]
      },
      { extend: 'colvis', text: 'Column Visibility', className: 'btn btn-radius' }
    ],
  }
}

// ngAfterViewInit(): void {
//   this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
//     dtInstance.columns().every(function () {
//       const that = this;
//       $('input', this.footer()).on('keyup change', function () {
//         if (that.search() !== this['value']) {
//           that
//             .search(this['value'])
//             .draw();
//         }
//       });
//     });
//   });
// }
ngAfterViewInit(): void {
  this.dtTrigger.next();
}

ngOnDestroy(): void {
  this.dtTrigger.unsubscribe();
}
      deletes()
{
  Swal.fire({
    position: 'top-end',
    title: 'Do You Want To Delete',
    text: 'If Deleted, Data can not be reverted back!',
    icon: 'warning' ,
    showCancelButton: true,
    confirmButtonText: 'Yes',
    cancelButtonText: 'No'
  }).then((result) => {
    if (result.value) {
      Swal.fire(
          'Data Record Deleted Successfully..'

      )
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      Swal.fire(
        'Changes will be Discarded..'
      )
    }
  })
}
GetDistrictDetails(){



  document.getElementById('loader-spinner').style.display = "block";
  this.data = this.service.GetallVLE();;
  this.data.subscribe((Response: any) => {
    this.DistrictDetailsList = Response;
    this.rerender();

     document.getElementById('loader-spinner').style.display = "none";
  }, (error) => {
    document.getElementById('loader-spinner').style.display = "none";
    if (error.status == 401 || error.status == 500) {
      this.errorHandler.HandlerError(error);
    }
    else if (error.status == 400) {
      swal('Warning!', error.error.Message, 'warning');


    }
  });
}
rerender(): void {
  try {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
    });
   this.dtTrigger.next();
  } catch (err) {
    console.log(err);
  }
}
delete(VL_Id){
  swal({
     title: 'Are you sure?', text: "You want to delete!", type: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!'
   }).then((result) => {
      if (result.value) {
      this.data = this.service.DeleteVLE(VL_Id);
      this.data.subscribe(
       (response: any) => {
        this.GetDistrictDetails()
          //alert('Inside');;
       }
    );
  }
  })
  }
}



// WEBPACK FOOTER //
// ./src/app/Pages/manage/vle/vlegrid/vlegrid.component.ts